<div style="min-width: 40vw; max-width: 650px;">
    <form [formGroup]="addItemForm">

        <!-- Section -->
        <div class="w-full">
            <div class="text-xl">{{title}}</div>
        </div>
        
        <div class="grid sm:grid-cols-4 gap-6 w-full dialog-content-height-scroll pb-1" [class.max-h-[35rem]]="data.constrainHeight">
            
            <div class="sm:col-span-4 grid sm:grid-cols-12 gap-x-6 gap-y-4 w-full mt-8">
                <ng-container *ngFor="let configItem of formConfig">
                    <mat-form-field
                        *ngIf="configItem.type != 'quill' && configItem.type != 'radio' && configItem.type != 'radioMulti' && configItem.type != 'iconSelect'"
                        [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)"
                        [subscriptSizing]="'dynamic'">
                        <mat-label>{{configItem.name | titlecase}}</mat-label>

                        <mat-icon
                            *ngIf="configItem.icon"
                            class="icon-size-5"
                            [svgIcon]="configItem.icon"
                            matPrefix></mat-icon>

                        <input
                            *ngIf="configItem.type != 'date' && configItem.type != 'textarea' && configItem.type != 'currency' && configItem.type != 'select'"
                            [formControlName]="getFormControlName(configItem)"
                            matInput>

                        <input
                            *ngIf="configItem.type == 'currency'"
                            matInput
                            type="text"
                            [value]="addItemForm?.get(getFormControlName(configItem))?.value ?? 0 | currency: '£'"
                            (blur)="updateCurrency($event, addItemForm, getFormControlName(configItem))">
                            
                        <textarea
                            *ngIf="configItem.type == 'textarea'"
                            style="max-height: 300px !important;"
                            [formControlName]="getFormControlName(configItem)"
                            cdkAutosizeMinRows="3"
                            cdkTextareaAutosize
                            matInput></textarea>
                            
                        <span *ngIf="configItem.type == 'percentage'" matSuffix>%</span>

                        <ng-container *ngIf="configItem.type == 'date'">
                            <input
                                [formControlName]="getFormControlName(configItem)"
                                [matDatepicker]="picker2"
                                matInput>
                            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </ng-container>

                        <mat-select *ngIf="configItem.type == 'select'"
                            [formControlName]="getFormControlName(configItem)">
                            <ng-container *ngFor="let option of configItem.options">
                                <mat-option [value]="option.value">
                                    <div class="font-medium">{{option.name}}</div>
                                    <div *ngIf="option.info" class="mt-1.5 text-sm whitespace-normal leading-normal text-secondary">{{option.info}}</div>
                                </mat-option>
                            </ng-container>
                        </mat-select>

                    </mat-form-field>
                    
                    <div
                        *ngIf="configItem.type == 'iconSelect'"
                        [class]="'w-full fuse-mat-dense flex flex-col gap-1 col-span-' + (configItem.colSpan ?? 12)">
                        <mat-label>{{configItem.name | titlecase}}</mat-label>

                        <button
                            class="bg-primary text-white"
                            mat-icon-button
                            [matMenuTriggerFor]="chooseIconMenu">
                            <span class="material-icons">{{addItemForm.controls[getFormControlName(configItem)].value}}</span>
                        </button>
                        <mat-menu #chooseIconMenu="matMenu" class="flex flex-wrap gap-1 px-2">
                            <ng-container *ngFor="let option of configItem.options">
                                <span
                                    class="material-icons mr-1 text-primary cursor-pointer"
                                    (click)="setIcon(option.value, getFormControlName(configItem))"
                                    style="font-size: 24px; width: 24px; height: 24px;">{{option.value}}</span>
                            </ng-container>
                        </mat-menu>
                    </div>

                    <div
                        *ngIf="configItem.type == 'quill'"
                        [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">
                        <mat-label>{{configItem.name | titlecase}}</mat-label>
                        <quill-editor
                            class="w-full mt-1"
                            style="max-height: 300px !important;"
                            [formControlName]="getFormControlName(configItem)"
                            [bounds]="'self'"
                            [modules]="quillModules"
                            (onEditorCreated)="onEditorCreated($event)">
                        </quill-editor>
                    </div>

                    <div
                        *ngIf="configItem.type == 'radio'"
                        [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">

                        <mat-label>{{configItem.name | titlecase}}</mat-label>

                        <mat-tab-group *ngIf="configItem.hasTabs" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="configItem.selectedTab" (selectedIndexChange)="configItem.selectedTab = $event;">
                            <ng-container *ngFor="let tab of getTabNames(configItem)">
                                <mat-tab [label]="tab"></mat-tab>
                            </ng-container>
                        </mat-tab-group>

                        <mat-radio-group
                            [formControlName]="getFormControlName(configItem)"
                            class="flex flex-col"
                            [class.gap-y-0]="!anyOptionsHaveInfo(configItem)"
                            [class.gap-y-2]="anyOptionsHaveInfo(configItem)"
                            [class.mt-2]="configItem.name">
                            <ng-container *ngFor="let option of getRadioOptions(configItem)">
                                <mat-radio-button class="-mt-1" [value]="option.value">
                                    <div>
                                        <div class="font-medium">{{option.name}}</div>
                                        <div *ngIf="option.info" class="-mt-0.5 text-sm whitespace-normal leading-normal text-secondary">{{option.info}}</div>
                                    </div>
                                </mat-radio-button>
                            </ng-container>
                        </mat-radio-group>
                    </div>

                    <div
                        *ngIf="configItem.type == 'radioMulti'"
                        [class]="'w-full fuse-mat-dense col-span-' + (configItem.colSpan ?? 12)">

                        <div class="sticky top-0 z-999 bg-card pb-4 pt-2 mb-2 border-b -mt-2 flex flex-wrap gap-x-2">
                            <ng-container *ngFor="let item of addItemForm.controls[getFormControlName(configItem)].value; let i = index;">
                                <mat-chip class="my-1" [removable]="true" (removed)="removeRadioMultiChip(i, getFormControlName(configItem))">
                                  {{ getOptionName(configItem.options, item) }}
                                  <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </ng-container>
                        </div>

                        <mat-tab-group *ngIf="configItem.hasTabs" mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="configItem.selectedTab" (selectedIndexChange)="configItem.selectedTab = $event;">
                            <ng-container *ngFor="let tab of getTabNames(configItem)">
                                <mat-tab [label]="tab"></mat-tab>
                            </ng-container>
                        </mat-tab-group>

                        <mat-label>{{configItem.name | titlecase}}</mat-label>
                        <div
                            class="flex flex-col"
                            [class.gap-y-0]="!anyOptionsHaveInfo(configItem)"
                            [class.gap-y-2]="anyOptionsHaveInfo(configItem)">

                            <ng-container *ngFor="let option of getRadioOptions(configItem)">
                                <div class="flex gap-2 items-center" (click)="!isSelectedInRadioMulti(getFormControlName(configItem), option.value) && addToRadioMulti(option.value, getFormControlName(configItem))">
                                    <button mat-icon-button class="w-8 h-8 min-h-8" color="primary" [disabled]="isSelectedInRadioMulti(getFormControlName(configItem), option.value)">
                                        <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                                    </button>
                                    <div>
                                        <div class="font-medium">{{option.name}}</div>
                                        <div *ngIf="option.info" class="-mt-0.5 text-sm whitespace-normal leading-normal text-secondary">{{option.info}}</div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                    </div>

                </ng-container>
            </div>
        </div>

        <!-- Divider -->
        <div class="mt-8 mb-8 border-t"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end">
            <ng-container *ngIf="data.buttons">
                <div class="mr-auto flex items-center">
                    <ng-container *ngFor="let button of data.buttons">
                        <button
                            (click)="doButtonCallback(button)"
                            class="mr-4"
                            mat-flat-button
                            [color]="'primary'"
                        >{{button.name}}</button>
                    </ng-container>
                </div>
            </ng-container>
            <button
                (click)="close()"
                mat-stroked-button
                type="button">
                Cancel
            </button>
            <button
                (click)="save()"
                class="ml-4"
                mat-flat-button
                type="button"
                [color]="'primary'"
                [disabled]="!addItemForm?.valid || (!data.allowPristineSave && addItemForm?.pristine)">
                Save                
            </button>
        </div>
    </form>

</div>
